import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CsIconModule } from '@components/icon';
import { KeyboardInsetDirective } from 'client/directives/keyboard-inset/keyboard-inset.directive';
import { ReportFeedbackSheetComponent } from './report-feedback-sheet.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CsIconModule,
    KeyboardInsetDirective,
  ],
  declarations: [ReportFeedbackSheetComponent],
  exports: [ReportFeedbackSheetComponent],
})
export class ReportFeedbackSheetModule { }
